import { TFunction } from 'i18next';
import { TYPE_OF_PURCHASE, getSlotPackageDisplayName } from '../../BookingManagement/components/CreateBooking/constants/DetailedBookingConstants';
import {
  DropdownFieldProps,
  FormFieldHookProps,
} from '../interfaces/formField.interfaces';

const TYPE_OF_PURCHASE_LIST = [
  TYPE_OF_PURCHASE.GP_CLASS,
  TYPE_OF_PURCHASE.GP_SOV,
  TYPE_OF_PURCHASE.NGP,
].map((name) => ({ name }));

export const getDropdownFieldsConfig = (
  t: TFunction,
  formFieldProps: FormFieldHookProps
): DropdownFieldProps[] => [
  {
    label: t('edit-inventory-type-of-purchase-label'),
    value: formFieldProps.selectedTypeOfPurchase,
    onChange: formFieldProps.setSelectedTypeOfPurchase,
    disabled: !formFieldProps.selectedArtEvent,
    placeholder: t('edit-inventory-type-of-purchase-placeholder'),
    items: TYPE_OF_PURCHASE_LIST.map((item) => ({
      key: item.name,
      value: item.name,
      label: item.name,
    })),
  },
  {
    label: t('edit-inventory-slot-package-label'),
    value: formFieldProps.selectedSlotPackage,
    onChange: formFieldProps.setSelectedSlotPackage,
    disabled:
      !formFieldProps.selectedArtEvent ||
      !formFieldProps.selectedTypeOfPurchase ||
      formFieldProps.isLoadingSlotPackages,
    placeholder: t('edit-inventory-slot-package-placeholder'),
    items: formFieldProps.slotPackages.map((pkg) => ({
      key: pkg.slotPackageName,
      value: pkg.slotPackageName,
      label: getSlotPackageDisplayName(pkg.slotPackageName),
    })),
  },
  {
    label: t('edit-inventory-segment-label'),
    value: formFieldProps.selectedSegment,
    onChange: formFieldProps.setSelectedSegment,
    disabled: !formFieldProps.selectedSlotPackage,
    placeholder: t('edit-inventory-segment-placeholder'),
    items: formFieldProps.segments.map((seg) => ({
      key: seg.segmentName,
      value: seg.segmentName,
      label: seg.segmentName,
    })),
  },
];
